import logo from './occupation.png';
import './App.css';
// import Register from './Component/register';
import AppRouter from './Component/config/router.js';

function App() {
  return (
      <div>
        <AppRouter />
      </div>
  );
}

export default App;
